import { Button } from '@givebutter/primitives/button';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { show as showIntercomChat } from '@intercom/messenger-js-sdk';
import * as SettingsCard from 'components/settings-card';

const GivingHubSettings = () => {
    return (
        <SettingsCard.Root>
            <SettingsCard.LeftSide>
                <SettingsCard.Heading>Giving Hub</SettingsCard.Heading>
                <p className="text-sm text-gray-700">
                    Upgrade your Landing Page to a Giving Hub to boost your organization with a
                    beautiful website.{' '}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://demo.givebutter.com/dance-marathon"
                    >
                        See a demo
                    </a>
                    .
                </p>
            </SettingsCard.LeftSide>
            <SettingsCard.RightSide className="flex flex-col gap-2">
                <Button
                    variant="solid"
                    className="self-start !border-sky-100 !bg-sky-100 !text-sky-700"
                    size="lg"
                    onClick={e => {
                        e.preventDefault();
                        showIntercomChat();
                    }}
                >
                    Chat with us
                    <FontAwesomeIcon icon={faArrowRight} />
                </Button>
                <p className="text-sm text-gray-700">It's free - just ask us!</p>
            </SettingsCard.RightSide>
        </SettingsCard.Root>
    );
};

export { GivingHubSettings };
